import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const PublicLayout = ({ children, eyebrow, title, description }) => {
  return (
    <main className="public-page">
      <header className="public-header">
        <Container className="public-header-inner">
          <Link to="/about" className="public-brand">
            Owner Builder
          </Link>
        </Container>
      </header>

      <section className="public-title-band">
        <Container>
          {eyebrow && <div className="public-eyebrow">{eyebrow}</div>}
          <h1>{title}</h1>
          {description && <p>{description}</p>}
        </Container>
      </section>

      <Container className="public-body">{children}</Container>
    </main>
  );
};

export default PublicLayout;
